import React, { Component } from "react";
import { CookiesProvider } from "react-cookie";
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import logo from "./logo.svg";
import "./App.scss";
import Main from "./Views/Main";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.state = {
      scrollTop: 0,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll(event) {
    var top = window.pageYOffset || document.documentElement.scrollTop;

    this.setState({
      scrollTop: top,
    });
  }

  render() {
    return (
      <CookiesProvider>
        <Router basename="/">
          <div
            className={`App${this.state.scrollTop > 0 ? " isScrolled" : ""} ${
              this.state.scrollTop > 200 ? " isScrolledHero" : ""
            }`}
          >
            <Switch>
              <Route exact path="/" render={(props) => <Main {...props} />}>
                <Redirect to="/et" />
              </Route>
              <Route
                path="/:lang/:seturl"
                render={(props) => <Main {...props} />}
              />

              <Route path="/:lang" render={(props) => <Main {...props} />} />
            </Switch>
          </div>
        </Router>
      </CookiesProvider>
    );
  }
}
